module.exports = __webpack_public_path__ + "static/yieldr.54c10f88.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/documents/pdfs/yieldr.pdf
// module id = 1534
// module chunks = 157636680307020